module.exports = __webpack_public_path__ + "static/media/30.a01a91ae.png";